(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('MeasurementUnit', MeasurementUnit);

    MeasurementUnit.$inject = ['$resource'];

    function MeasurementUnit ($resource) {
        var resourceUrl =  'api/measurement-units/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
